import React from 'react';
import {action} from 'mobx'
import {observer, inject} from 'mobx-react'

import {Droppable, Draggable} from 'react-beautiful-dnd';

import Card from "./Card";

const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#FAFAFA' : 'transparent',
});


@inject("rootStore") @observer
export default class BlockBody extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};


        this.handleEditCard = this.handleEditCard.bind(this);

    }

    render() {

        const {rootStore, blockStore, provided, snapshot} = this.props;

        const cards = blockStore.filteredCards();

        return (


            <div className="notes">
                <ul ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    className='cards-list list-unstyled'
                    key={blockStore.id}
                >

                    {cards.map((c, index) =>
                        (
                            <Card key={c.id} index={index} card={c} blockStore={blockStore}/>
                        )
                    )}

                </ul>
            </div>
        );
    }

    @action
    handleEditCard(card, e) {
        const {blockStore} = this.props;
        blockStore.showEditingCardBlockModal(card);

    }

    // shouldComponentUpdate() {
    //     const {snapshot} = this.props;

    //     return snapshot.isDraggingOver;
    // }

}



